var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FormInput',{attrs:{"value":_vm.value,"type":_vm.isMultiSelect ? 'multiselect' : 'select',"items":_vm.selectItems,"showVals":true,"placeholder":_vm.placeholder},on:{"input":val => _vm.$emit('input', val)}})
}
var staticRenderFns = []

export { render, staticRenderFns }